<section class="grid">
  <ui-card class="panel panel--users-list">
    <div class="panel--users-list__sticky">
      <div class="panel__header">
        <div>
          <h2 class="panel__title-with-count">
            <span>Comptes</span>
            <span class="panel__count-badge">{{ filteredUsers.length }}</span>
          </h2>
        </div>
        <button
          type="button"
          class="btn-icon btn-icon-refresh"
          (click)="reloadUsers()"
          [disabled]="loadingUsers"
          [title]="'admin.common.refresh' | adminTranslate"
          [attr.aria-label]="'admin.common.refresh' | adminTranslate">
          <ui-icon name="refresh"></ui-icon>
        </button>
      </div>

      <div class="toolbar">
        <ui-input [(ngModel)]="userSearch" type="search" [placeholder]="'admin.users.searchPlaceholder' | adminTranslate"></ui-input>
      </div>
    </div>

    @if (loadingUsers) {
      <p class="empty">{{ 'admin.users.loading' | adminTranslate }}</p>
    } @else {
      <div class="user-list">
        @for (user of filteredUsers; track user.id) {
          <button type="button" class="user-card" [class.user-card--selected]="selectedUser?.id === user.id" (click)="openUser(user)">
            <div class="user-cover user-cover--no-banner">
              @if (user.profileImageUrl) {
                <img [src]="user.profileImageUrl" [alt]="user.username" class="user-cover-img" />
              }
              <div class="user-cover-overlay"></div>
              <div class="user-cover-row">
                <div class="user-avatar">
                  @if (user.profileImageUrl) {
                    <img [src]="user.profileImageUrl" [alt]="user.username" class="user-avatar-img" />
                  } @else {
                    <span>{{ user.username ? (user.username[0] | uppercase) : 'U' }}</span>
                  }
                </div>
                <div class="user-cover-info user-cover-info--stacked">
                  <span class="user-cover-kicker">{{ rolesSummary(user.roles) }}</span>
                  <span class="user-name">{{ user.username }}</span>
                </div>
              </div>
            </div>
          </button>
        }
        @if (!filteredUsers.length) {
          <p class="empty">{{ 'admin.users.empty' | adminTranslate }}</p>
        }
      </div>
    }
  </ui-card>

  @if (selectedUser) {
  <ui-card class="panel panel--users-detail">
    <div class="panel__header">
      <div>
        <h2>{{ 'admin.users.targetTitle' | adminTranslate }}</h2>
      </div>
      <div class="section-block__actions">
        @if (isCurrentUserAdmin) {
          <ui-button
            variant="secondary"
            size="sm"
            (click)="openUserDashboardPreview()"
            [disabled]="!selectedUser">
            {{ 'admin.users.openDashboardPreview' | adminTranslate }}
          </ui-button>
        }
        <ui-button
          variant="primary"
          size="sm"
          (click)="openSupportModal()"
          [disabled]="!selectedUser">
          {{ 'admin.common.openSupportSession' | adminTranslate }}
        </ui-button>
      </div>
    </div>

    @if (selectedUser; as user) {
      <div class="detail-grid">
        <div class="detail-summary-card">
          <div class="detail-summary-item">
            <span>{{ 'admin.users.username' | adminTranslate }}</span>
            <strong>{{ user.username }}</strong>
          </div>
          <div class="detail-summary-item">
            <span>{{ 'admin.users.createdAt' | adminTranslate }}</span>
            <strong>{{ user.createdAt ? (user.createdAt | date:'dd/MM/yyyy HH:mm') : ('admin.common.unknown' | adminTranslate) }}</strong>
          </div>
          <div class="detail-summary-item">
            <span>{{ 'admin.users.id' | adminTranslate }}</span>
            <strong class="detail-row__mono">{{ user.id }}</strong>
          </div>
        </div>
      </div>

      <div class="section-block">
        <div class="section-block__header">
          <h3>{{ 'admin.users.activeSupportTitle' | adminTranslate }}</h3>
          @if (activeSupportSession?.status === 'ACTIVE') {
            <ui-badge variant="warning" appearance="soft" size="xs" uppercase>
              {{ 'admin.common.active' | adminTranslate }}
            </ui-badge>
          }
        </div>
        @if (loadingActiveSupportSession) {
          <p class="empty">{{ 'admin.support.loading' | adminTranslate }}</p>
        } @else if (activeSupportSession; as session) {
          <div class="detail-summary-card">
            <div class="detail-summary-item">
              <span>{{ 'admin.users.activeSupportOpenedBy' | adminTranslate }}</span>
              <strong>{{ session.actorUsername || session.actorUserId }}</strong>
            </div>
            <div class="detail-summary-item">
              <span>{{ 'admin.users.activeSupportOpenedAt' | adminTranslate }}</span>
              <strong>{{ session.createdAt ? (session.createdAt | date:'dd/MM/yyyy HH:mm') : ('admin.common.unknown' | adminTranslate) }}</strong>
            </div>
            <div class="detail-summary-item">
              <span>{{ 'admin.users.activeSupportExpiresAt' | adminTranslate }}</span>
              <strong>{{ session.expiresAt ? (session.expiresAt | date:'dd/MM/yyyy HH:mm') : ('admin.common.unknown' | adminTranslate) }}</strong>
            </div>
            <div class="detail-summary-item">
              <span>{{ 'admin.users.activeSupportReason' | adminTranslate }}</span>
              <strong>{{ session.reason || ('admin.support.noReason' | adminTranslate) }}</strong>
            </div>
          </div>
          @if (activeSupportSessionHint(session); as hint) {
            <p class="integration-panel-desc">{{ hint }}</p>
          }
          <div class="section-block__actions">
            <ui-button
              variant="primary"
              size="sm"
              (click)="resumeActiveSupportSession()"
              [disabled]="resumingSupportSessionId === session.id || !canResumeSupportSession(session)">
              {{ resumingSupportSessionId === session.id ? ('admin.support.resuming' | adminTranslate) : ('admin.support.resume' | adminTranslate) }}
            </ui-button>
            <ui-button variant="secondary" size="sm" [routerLink]="['/support']">
              {{ 'admin.users.activeSupportOpenList' | adminTranslate }}
            </ui-button>
          </div>
        } @else {
          <p class="empty">{{ 'admin.users.noActiveSupport' | adminTranslate }}</p>
        }
      </div>

      <div class="section-block">
        <div class="section-block__header">
          <h3>{{ 'admin.users.integrations' | adminTranslate }}</h3>
          <button
            type="button"
            class="btn-icon btn-icon-refresh"
            (click)="loadSelectedUserDetails()"
            [disabled]="loadingUserDetails"
            [title]="'admin.common.refresh' | adminTranslate"
            [attr.aria-label]="'admin.common.refresh' | adminTranslate">
            <ui-icon name="refresh"></ui-icon>
          </button>
        </div>
        @if (loadingUserDetails) {
          <p class="empty">{{ 'admin.users.loadingIntegrations' | adminTranslate }}</p>
        } @else {
          <div class="integrations-merged-layout">
            <div class="integrations-merged-tabs" role="tablist" [attr.aria-label]="'admin.users.integrationsAriaLabel' | adminTranslate">
              @for (provider of integrationProviders; track provider.key) {
                <ui-tab
                  [label]="provider.labelKey | adminTranslate"
                  [tabId]="'integration-tab-' + provider.key.toLowerCase()"
                  [panelId]="'integration-panel-' + provider.key.toLowerCase()"
                  [active]="activeIntegrationTab === provider.key"
                  [badge]="integrationLinked(provider.key) ? 1 : 0"
                  (tabSelect)="setActiveIntegrationTab(provider.key)">
                </ui-tab>
              }
            </div>

            <div class="integrations-merged-right">
              @if (activeIntegrationTab === 'SPOTIFY' && integrationAccount('SPOTIFY'); as account) {
                <div class="integration-panel" id="integration-panel-spotify" role="tabpanel" aria-labelledby="integration-tab-spotify">
                  <p class="integration-panel-desc">{{ integrationDescription('SPOTIFY') }}</p>
                  @if (spotifyNowPlaying && spotifyNowPlaying.trackName && spotifyNowPlaying.trackName !== '—') {
                    <div class="spotify-now-block">
                      <ui-badge class="spotify-now-badge" [variant]="spotifyNowPlaying.playing ? 'success' : 'neutral'" [appearance]="spotifyNowPlaying.playing ? 'solid' : 'soft'" size="xs" uppercase>
                        {{ (spotifyNowPlaying.playing ? 'admin.users.spotify.playing' : 'admin.users.spotify.paused') | adminTranslate }}
                      </ui-badge>
                      <div class="spotify-now-row">
                        @if (spotifyNowPlaying.albumImageUrl) {
                          <div class="spotify-now-cover">
                            <img [src]="spotifyNowPlaying.albumImageUrl" [alt]="spotifyNowPlaying.albumName || ('admin.users.spotify.albumCoverAlt' | adminTranslate)" />
                          </div>
                        }
                        <div class="spotify-now-info">
                          <div class="spotify-now-track">
                            <span class="spotify-now-title">{{ spotifyNowPlaying.trackName }}</span>
                            <span class="spotify-now-artist">{{ spotifyNowPlaying.artistName }}</span>
                            @if (spotifyNowPlaying.playlistName && spotifyNowPlaying.playlistName !== '—') {
                              <span class="spotify-now-playlist">#{{ spotifyNowPlaying.playlistName }}</span>
                            }
                          </div>
                          @if (spotifyNowPlaying.trackUrl) {
                            <a [href]="spotifyNowPlaying.trackUrl" target="_blank" rel="noopener noreferrer" class="spotify-now-link" [title]="'admin.users.spotify.open' | adminTranslate">{{ 'admin.users.spotify.open' | adminTranslate }}</a>
                          }
                        </div>
                      </div>
                    </div>
                  } @else {
                    <p class="integration-panel-desc">{{ 'admin.users.spotify.empty' | adminTranslate }}</p>
                  }
                </div>
              } @else if (activeIntegrationTab === 'DISCORD' && integrationAccount('DISCORD'); as account) {
                <div class="integration-panel" id="integration-panel-discord" role="tabpanel" aria-labelledby="integration-tab-discord">
                  @if (discordProfile; as profile) {
                    <div class="discord-dashboard-profile">
                      @if (profile.avatarUrl) {
                        <img [src]="profile.avatarUrl" [alt]="profile.username" class="discord-dashboard-avatar" />
                      } @else {
                        <span class="discord-dashboard-avatar discord-dashboard-avatar--placeholder">{{ profile.username ? profile.username[0] : '?' }}</span>
                      }
                      <span class="discord-dashboard-username">{{ profile.username }}</span>
                    </div>
                  }
                  @if (discordLinkedServers.length > 0) {
                    @if (shouldAnimateDiscordServers) {
                      <div class="discord-linked-servers-marquee-mask">
                        <div class="discord-linked-servers-marquee-list discord-linked-servers-marquee-list--animated" role="list" [attr.aria-label]="'admin.users.providers.DISCORD' | adminTranslate">
                          @for (server of discordLinkedServers; track server.id) {
                            <div role="listitem" class="discord-linked-server-dashboard discord-linked-server-dashboard--marquee">
                              @if (server.guildIconUrl) {
                                <img [src]="server.guildIconUrl" [alt]="server.guildName || server.guildId" class="discord-dashboard-avatar discord-dashboard-avatar--guild" />
                              } @else {
                                <span class="discord-dashboard-avatar discord-dashboard-avatar--placeholder discord-dashboard-avatar--guild">{{ (server.guildName || server.guildId) ? (server.guildName || server.guildId)![0] : '?' }}</span>
                              }
                              <div class="discord-linked-server-dashboard-info">
                                <div class="discord-guild-dashboard-title-row">
                                  <span class="discord-guild-dashboard-name">{{ server.guildName || server.guildId }}</span>
                                  @if (server.primary) {
                                    <span class="discord-dashboard-primary-badge">{{ 'admin.users.primary' | adminTranslate }}</span>
                                  }
                                </div>
                                @if (server.memberCount != null || server.presenceCount != null) {
                                  <span class="discord-guild-dashboard-stats">{{ server.presenceCount ?? 0 }} en ligne • {{ server.memberCount ?? 0 }} membres</span>
                                }
                              </div>
                            </div>
                          }
                          @for (server of discordLinkedServers; track 'clone-' + (server.id || $index)) {
                            <div aria-hidden="true" class="discord-linked-server-dashboard discord-linked-server-dashboard--marquee discord-linked-server-dashboard--clone">
                              @if (server.guildIconUrl) {
                                <img [src]="server.guildIconUrl" alt="" class="discord-dashboard-avatar discord-dashboard-avatar--guild" />
                              } @else {
                                <span class="discord-dashboard-avatar discord-dashboard-avatar--placeholder discord-dashboard-avatar--guild">{{ (server.guildName || server.guildId) ? (server.guildName || server.guildId)![0] : '?' }}</span>
                              }
                              <div class="discord-linked-server-dashboard-info">
                                <div class="discord-guild-dashboard-title-row">
                                  <span class="discord-guild-dashboard-name">{{ server.guildName || server.guildId }}</span>
                                  @if (server.primary) {
                                    <span class="discord-dashboard-primary-badge">{{ 'admin.users.primary' | adminTranslate }}</span>
                                  }
                                </div>
                                @if (server.memberCount != null || server.presenceCount != null) {
                                  <span class="discord-guild-dashboard-stats">{{ server.presenceCount ?? 0 }} en ligne • {{ server.memberCount ?? 0 }} membres</span>
                                }
                              </div>
                            </div>
                          }
                        </div>
                      </div>
                    } @else {
                      <div class="discord-linked-servers-dashboard">
                        @for (server of discordLinkedServers; track server.id) {
                          <div class="discord-linked-server-dashboard">
                            @if (server.guildIconUrl) {
                              <img [src]="server.guildIconUrl" [alt]="server.guildName || server.guildId" class="discord-dashboard-avatar discord-dashboard-avatar--guild" />
                            } @else {
                              <span class="discord-dashboard-avatar discord-dashboard-avatar--placeholder discord-dashboard-avatar--guild">{{ (server.guildName || server.guildId) ? (server.guildName || server.guildId)![0] : '?' }}</span>
                            }
                            <div class="discord-linked-server-dashboard-info">
                              <div class="discord-guild-dashboard-title-row">
                                <span class="discord-guild-dashboard-name">{{ server.guildName || server.guildId }}</span>
                                @if (server.primary) {
                                  <span class="discord-dashboard-primary-badge">{{ 'admin.users.primary' | adminTranslate }}</span>
                                }
                              </div>
                              @if (server.memberCount != null || server.presenceCount != null) {
                                <span class="discord-guild-dashboard-stats">{{ server.presenceCount ?? 0 }} en ligne • {{ server.memberCount ?? 0 }} membres</span>
                              }
                            </div>
                          </div>
                        }
                      </div>
                    }
                  } @else if (discordStats && (discordStats.connectedCount != null || discordStats.memberCount != null)) {
                    <ul class="integration-stats-list">
                      @if (discordStats.connectedCount != null) {
                        <li><strong>{{ 'admin.users.connected' | adminTranslate }}</strong> : {{ discordStats.connectedCount }}</li>
                      }
                      @if (discordStats.memberCount != null) {
                        <li><strong>{{ 'admin.users.members' | adminTranslate }}</strong> : {{ discordStats.memberCount }}</li>
                      }
                    </ul>
                  } @else {
                    <p class="integration-panel-desc">{{ 'admin.users.discord.empty' | adminTranslate }}</p>
                  }
                </div>
              } @else if (integrationAccount(activeIntegrationTab); as account) {
                <div class="integration-panel" [attr.id]="'integration-panel-' + activeIntegrationTab.toLowerCase()" role="tabpanel" [attr.aria-labelledby]="'integration-tab-' + activeIntegrationTab.toLowerCase()">
                  <p class="integration-panel-desc">{{ integrationDescription(activeIntegrationTab) }}</p>
                  <ul class="integration-stats-list">
                    <li><strong>{{ 'admin.users.status' | adminTranslate }}</strong> : {{ 'admin.users.connectedStatus' | adminTranslate }}</li>
                    <li><strong>{{ 'admin.users.identifier' | adminTranslate }}</strong> : {{ account.providerUserId || ('admin.users.identifierUnavailable' | adminTranslate) }}</li>
                    <li><strong>{{ 'admin.users.expiration' | adminTranslate }}</strong> : {{ expiresLabel(account.expiresAt) }}</li>
                    @if (integrationLastUpdate(account); as updatedAt) {
                      <li><strong>{{ 'admin.users.updatedAtLabel' | adminTranslate }}</strong> : {{ updatedAt }}</li>
                    }
                  </ul>
                </div>
              } @else {
                <div class="integration-panel" [attr.id]="'integration-panel-' + activeIntegrationTab.toLowerCase()" role="tabpanel" [attr.aria-labelledby]="'integration-tab-' + activeIntegrationTab.toLowerCase()">
                  <p class="integration-panel-desc">{{ integrationDescription(activeIntegrationTab) }}</p>
                  <p class="integration-panel-not-linked">{{ 'admin.users.notLinked' | adminTranslate:{ provider: integrationProviderLabel(activeIntegrationTab) } }}</p>
                </div>
              }
            </div>
          </div>
        }
      </div>

      <div class="section-block">
        <div class="section-block__header">
          <h3>{{ 'admin.twitchBots.chatRouting.title' | adminTranslate }}</h3>
        </div>
        @if (loadingTwitchChatbotDiagnostic) {
          <p class="empty">{{ 'admin.twitchBots.loading' | adminTranslate }}</p>
        } @else if (twitchChatbotDiagnostic; as diagnostic) {
          <div class="chatbot-diagnostic-card">
            <div class="chatbot-diagnostic-card__summary">
              <div>
                <span class="chatbot-diagnostic-card__kicker">{{ 'admin.twitchBots.chatRouting.title' | adminTranslate }}</span>
                <div class="chatbot-diagnostic-card__title-row">
                  <strong>{{ complianceStatusKey(diagnostic) | adminTranslate }}</strong>
                  <span [class]="chatbotLevelBadgeClass(diagnostic)">
                    {{ chatbotLevelLabelKey(diagnostic) | adminTranslate }}
                  </span>
                </div>
                <p class="integration-panel-desc">{{ complianceDescriptionKey(diagnostic) | adminTranslate }}</p>
              </div>
            </div>

            <div class="chatbot-diagnostic-grid">
              <div class="chatbot-diagnostic-metric">
                <span>{{ 'admin.twitchBots.chatRouting.runtime.channel' | adminTranslate }}</span>
                <strong>{{ diagnostic.channelLogin || '-' }}</strong>
              </div>
              <div class="chatbot-diagnostic-metric">
                <span>{{ 'admin.twitchBots.chatRouting.table.eventsub' | adminTranslate }}</span>
                <strong>{{ (diagnostic.chatCommandsViaEventsub ? 'admin.twitchBots.chatRouting.eventsubOn' : 'admin.twitchBots.chatRouting.eventsubOff') | adminTranslate }}</strong>
              </div>
              <div class="chatbot-diagnostic-metric">
                <span>{{ 'admin.twitchBots.chatRouting.table.strict' | adminTranslate }}</span>
                <strong>{{ (diagnostic.chatbotStrictHelixOnly ? 'admin.twitchBots.chatRouting.strictOn' : 'admin.twitchBots.chatRouting.strictOff') | adminTranslate }}</strong>
              </div>
              <div class="chatbot-diagnostic-metric">
                <span>{{ 'admin.twitchBots.chatRouting.runtime.bot' | adminTranslate }}</span>
                <strong>{{ (diagnostic.botRegistered ? 'admin.twitchBots.chatRouting.runtime.registered' : 'admin.twitchBots.chatRouting.runtime.notRegistered') | adminTranslate }}</strong>
              </div>
              <div class="chatbot-diagnostic-metric">
                <span>{{ 'admin.twitchBots.chatRouting.runtime.connection' | adminTranslate }}</span>
                <strong>{{ (diagnostic.botConnected ? 'admin.twitchBots.chatRouting.runtime.connected' : 'admin.twitchBots.chatRouting.runtime.disconnected') | adminTranslate }}</strong>
              </div>
              <div class="chatbot-diagnostic-metric">
                <span>{{ 'admin.twitchBots.chatRouting.runtime.delivery' | adminTranslate }}</span>
                <strong>{{ deliveryModeKey(diagnostic) | adminTranslate }}</strong>
              </div>
              <div class="chatbot-diagnostic-metric">
                <span>{{ 'admin.twitchBots.chatRouting.runtime.sender' | adminTranslate }}</span>
                <strong>{{ diagnostic.senderUserIdAvailable ? (diagnostic.senderUserId || '-') : '-' }}</strong>
              </div>
            </div>
          </div>
        } @else {
          <p class="empty">{{ 'admin.twitchBots.chatRouting.empty' | adminTranslate }}</p>
        }
      </div>

      @if (canEditUserRoles) {
      <div class="section-block">
        <div class="section-block__header">
          <h3>{{ 'admin.users.roles' | adminTranslate }}</h3>
          <div class="section-block__actions">
            <ui-button [variant]="'primary'" size="sm" (click)="saveRoles()" [disabled]="savingRoles || !selectedUser">
              {{ savingRoles ? ('admin.common.saving' | adminTranslate) : ('admin.users.saveRoles' | adminTranslate) }}
            </ui-button>
            <ui-button variant="secondary" size="sm" (click)="resetRoleDraft()" [disabled]="savingRoles">{{ 'admin.common.reset' | adminTranslate }}</ui-button>
          </div>
        </div>
        <div class="toggle-grid toggle-grid--roles">
          @for (role of availableRoles; track role.key) {
            <ui-toggle
              class="toggle-card"
              [checked]="isRoleSelected(role.key)"
              (checkedChange)="toggleRole(role.key)"
              [disabled]="savingRoles || isProtectedSelfAdminRole(role.key)"
              [label]="role.labelKey | adminTranslate"
              [description]="roleDescription(role.key)">
            </ui-toggle>
          }
        </div>
        <textarea [(ngModel)]="roleChangeReason" rows="3" [placeholder]="'admin.users.roleReasonPlaceholder' | adminTranslate"></textarea>
      </div>
      }

      <div class="section-block">
        <div class="section-block__header">
          <h3>{{ 'admin.users.recentAudit' | adminTranslate }}</h3>
          <ui-button variant="secondary" size="sm" (click)="openAuditForSelectedUser()">{{ 'admin.users.viewUserAudit' | adminTranslate }}</ui-button>
        </div>
        @if (loadingUserDetails) {
          <p class="empty">{{ 'admin.users.loadingRecentAudit' | adminTranslate }}</p>
        } @else if (recentAuditEvents.length) {
          <div class="recent-audit-table-wrap">
            <table class="recent-audit-table">
              <thead>
                <tr>
                  <th>{{ 'admin.audit.event' | adminTranslate }}</th>
                  <th>{{ 'admin.audit.reason' | adminTranslate }}</th>
                  <th>{{ 'admin.audit.status' | adminTranslate }}</th>
                  <th>{{ 'admin.support.actions' | adminTranslate }}</th>
                </tr>
              </thead>
              <tbody>
                @for (row of paginatedRecentAuditRows; track row.id) {
                  <tr>
                    <td>
                      <div class="recent-audit-event-cell">
                        <strong>{{ recentAuditRowLabel(row) }}</strong>
                        @if (row.type === 'support-group' && row.supportSessionId) {
                          <span class="recent-audit-support-tag">Support</span>
                        }
                      </div>
                    </td>
                    <td>
                      <span class="recent-audit-reason">{{ recentAuditRowReason(row) }}</span>
                    </td>
                    <td>
                      <div class="recent-audit-status">
                        <span>{{ recentAuditRowDate(row) | date:'dd/MM/yyyy HH:mm' }}</span>
                        <span class="status" [class.status--active]="recentAuditRowSuccess(row)" [class.status--closed]="!recentAuditRowSuccess(row)">
                          {{ recentAuditRowSuccess(row) ? ('admin.common.status.success' | adminTranslate) : ('admin.common.status.error' | adminTranslate) }}
                        </span>
                      </div>
                    </td>
                    <td>
                      @if (row.type === 'support-group' && row.supportSessionId) {
                        <a class="inline-link" [routerLink]="['/audit']" [queryParams]="{ supportSessionId: row.supportSessionId }">{{ 'admin.users.openDetail' | adminTranslate }}</a>
                      } @else if (row.event; as event) {
                        <a class="inline-link" [routerLink]="['/audit', event.id]">{{ 'admin.users.openDetail' | adminTranslate }}</a>
                      }
                    </td>
                  </tr>
                }
              </tbody>
            </table>
          </div>
          @if (recentAuditRowCount > recentAuditPageSize) {
            <div class="recent-audit-pagination">
              <ui-button variant="secondary" size="sm" (click)="previousRecentAuditPage()" [disabled]="recentAuditPage <= 1">
                Precedent
              </ui-button>
              <span class="recent-audit-pagination__status">Page {{ recentAuditPage }} / {{ recentAuditTotalPages }}</span>
              <ui-button variant="secondary" size="sm" (click)="nextRecentAuditPage()" [disabled]="recentAuditPage >= recentAuditTotalPages">
                Suivant
              </ui-button>
            </div>
          }
        } @else {
          <p class="empty">{{ 'admin.users.noRecentAudit' | adminTranslate }}</p>
        }
      </div>

    }
  </ui-card>
  }
</section>

@if (supportModalOpen && selectedUser; as user) {
  <div
    class="support-modal-backdrop"
    (click)="closeSupportModal()"
    role="button"
    tabindex="0"
    (keydown.escape)="closeSupportModal()"
    [attr.aria-label]="'admin.common.close' | adminTranslate">
  </div>
  <div class="support-modal" role="dialog" aria-modal="true" aria-labelledby="support-modal-title">
    <div class="support-modal__content">
      <div class="support-modal__header">
        <div>
          <h2 id="support-modal-title" class="support-modal__title">{{ 'admin.users.supportSession' | adminTranslate }}</h2>
          <p class="support-modal__target">{{ 'admin.users.targetAccount' | adminTranslate:{ username: user.username } }}</p>
        </div>
        <button
          type="button"
          class="support-modal__close"
          (click)="closeSupportModal()"
          [disabled]="launchingSupport"
          [attr.aria-label]="'admin.common.close' | adminTranslate">
          &times;
        </button>
      </div>

      <textarea
        [(ngModel)]="supportReason"
        rows="4"
        [placeholder]="'admin.users.supportReasonPlaceholder' | adminTranslate">
      </textarea>

      <div class="toggle-grid toggle-grid--permissions">
        @for (permission of supportPermissions; track permission.key) {
          <ui-toggle
            class="toggle-card"
            [checked]="isPermissionSelected(permission.key)"
            (checkedChange)="togglePermission(permission.key)"
            [label]="permission.labelKey | adminTranslate"
            [description]="permissionDescription(permission.key)">
          </ui-toggle>
        }
      </div>

      <div class="support-modal__actions">
        <ui-button variant="secondary" (click)="closeSupportModal()" [disabled]="launchingSupport">
          {{ 'admin.common.cancel' | adminTranslate }}
        </ui-button>
        <ui-button [variant]="'primary'" (click)="launchSupportSession()" [disabled]="launchingSupport">
          {{ launchingSupport ? ('admin.common.opening' | adminTranslate) : ('admin.common.openSupportSession' | adminTranslate) }}
        </ui-button>
      </div>
    </div>
  </div>
}
